import config from '../../config';
class NpsScoreController {
  constructor(Authentication, PersonaCollection, SubscriptionUtils, $rootScope, $timeout) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      SubscriptionUtils,
      $rootScope,
      $timeout,
    });
  }

  $onInit() {
    this.user = null;
    this.initPsat();
  }

  async initPsat() {
    if (!config.PSAT_SURVEY_ENABLED) {
      return;
    }

    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(1000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
    const { isPremium, premiumTrialStartDate, subscriptionStartDate } = this.user.org;
    const isOnTrial = isPremium && premiumTrialStartDate && !subscriptionStartDate;
    this.subscriptionName = this.SubscriptionUtils.getSubscriptionNameDetailed(
      this.user.org.subscriptionLevel,
      isOnTrial
    );
  }

  onClose() {
    this.$rootScope.forcePsatDisplay = false;
  }

  get forceDisplay() {
    return this.$rootScope.forcePsatDisplay || false;
  }

  get usersCount() {
    return this.PersonaCollection.users.length;
  }

  get locationsCount() {
    return this.PersonaCollection.locations.length;
  }
}

export default {
  template: `
    <r-psat-score ng-if="!!ctrl.user && ctrl.usersCount"
      user="ctrl.user"
      locations-count="ctrl.locationsCount"
      users-count="ctrl.usersCount"
      subscription-name="{{ctrl.subscriptionName}}"
      save-client-flags="ctrl.saveClientFlags(flags)"
      on-close="ctrl.onClose()"
      force-display="ctrl.forceDisplay">
    </r-psat-score>
    `,
  controller: NpsScoreController,
  controllerAs: 'ctrl',
};
